import { CLEAR_SESSION, SET_SESSION } from '../constants/actionTypes'
import Session from '../libs/Session'

const initialState = new Session()

const session = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION:
      return action.session ? action.session : initialState

    case CLEAR_SESSION:
      return initialState

    default:
      return state
  }
}

export default session
